import React from 'react';

function ModernTemplateShoppingCart(): JSX.Element {
	return (
		<section>
			<h1>ModernTemplateShoppingCart</h1>
		</section>
	);
}

export default ModernTemplateShoppingCart;
